import '@/pages/dashboard/assets/scss/page/multiTimezone/components/ClockContent.scss';

import React, { useState, useEffect, useRef } from "react";
import { useIntl } from "umi";
import {
  Bubble,
    Button, Card
} from "tea-component";

import SvgIcon from '@/pages/home/components/SvgIcon';
import Clock from './Clock';
import EditRelatedGame from "@/pages/dashboard/pages/multiTimezone/compontnts/EditRelatedGame";

import { WorldClockData } from '@/pages/dashboard/pages/multiTimezone/_config/types'
import useWorldClockModel from "@/pages/dashboard/servicesModels/multiTimezone/worldClockModel";


export default function ClockContent(props: any) {
    
    // 时钟设置弹窗
    const [editModalVisible, setEditModalVisible] = useState(false);

    const { formatMessage } = useIntl();
    const { gameCode, filterLoading, timezoneType } = props
    const [isExpanded, setIsExpanded] = useState(false)
    const [showMoreCount, setShowMoreCount] = useState<number>(0)
    const worldClockContainerRef = useRef(null)
    const customClockDataListRef = useRef<WorldClockData[]>([])
    
    const { componentData: {defaultClockDataList, customClockDataList}, error, loading, setComponentData} = useWorldClockModel(props)
    
    useEffect(() => {
      window.addEventListener('resize', resizeUpdate)

      return () => {
        window.removeEventListener('resize', resizeUpdate)
      }
    }, [timezoneType])
    useEffect(() => {
      customClockDataListRef.current = customClockDataList
      resizeUpdate()
    }, [customClockDataList])
    
    //如果时钟总数一行放不下，则显示更多按钮，否则隐藏按钮
    const resizeUpdate = () => {
        setShowMoreCount(Math.ceil(customClockDataListRef.current.length - (worldClockContainerRef?.current?.clientWidth + 20) / 180));
    };
    
    const handleClick = () => {
        setIsExpanded(!isExpanded);
    };
    
    
    return (<div className="clock-content">
        <div className="multiTimezone-cont">
            <Card className="card-table-panel">
                <Card.Body
                        title={formatMessage({id: 'daily_by_time_zone_world_clock'})}
                        operation={<div className="card-sort-flex">
                            <Bubble dark content={formatMessage({id:'common_setting'})}>
                                <i className="card-sort-char" onClick={() => setEditModalVisible(true)}><SvgIcon
                                        className="card-sort-charicon" type="set-up"/></i>
                            </Bubble>
                        </div>}
                >
                    
                    <div className={
                        isExpanded ? 'clock-content-wrapHeight' : 'clock-content-wrap'
                    }
                         ref={worldClockContainerRef}
                    >
                        {
                            customClockDataList?.map((item) => {
                                return <Clock data={item} key={item.area_code}/>;
                            })
                        }
                    </div>
                    <div className={showMoreCount > 0 ? 'dbd-timezone-expend-hide' : 'dbd-timezone-expend-show'}>

                    </div>
                    <div className={`clock-content-btn ${showMoreCount > 0 ? 'show' : 'hide'}`}
                         onClick={handleClick}>
                        <Button type="link">{formatMessage({ id: isExpanded ? 'daily_by_time_zone_world_clock_show_less' : 'daily_by_time_zone_world_clock_show_more' })}</Button>
                        {!isExpanded ?
                            <span className="clock-content-btn-text">{`+${showMoreCount}`}<SvgIcon type="point-down" /></span> : null}
                    </div>
                
                </Card.Body>
            </Card>
            
            <EditRelatedGame
                visible={editModalVisible}
                close={() => {
                    setEditModalVisible(false);
                }}
                gameCode={gameCode}
                type={timezoneType}
                defaultClockDataList={defaultClockDataList}
                customClockDataList={customClockDataList}
                setCustomClockDataList={(newCustom: WorldClockData[]=[]) => {
                    setComponentData({defaultClockDataList, customClockDataList: newCustom});
                }}
            />
            
           
            
        </div>
    </div>);
}
